// src/features/orders/linehaulSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// ✅ Define the linehaul item type
interface Linehaul {
  id: string;
  customId: string;
  status: string;
  assignedCompanyName?: string;
  staffName?: string;
  [key: string]: any; // allow extra fields
}

// ✅ Define the state type
interface LinehaulState {
  list: any[];
  loading: boolean;
  error: string | null;
}

// ✅ Define update payload type
interface LinehaulStatusUpdatePayload {
  customId: string;
  status: string;
  assignedCompanyName?: string;
  staffName?: string;
}

// ✅ Initial state
const initialState: LinehaulState = {
  list: [],
  loading: false,
  error: null,
};

// ✅ Slice
const linehaulSlice = createSlice({
  name: 'linehaul',
  initialState,
  reducers: {
    setLinehaulList(state, action: PayloadAction<any[]>) {
      state.list = action.payload;
      state.loading = false;
    },

    addLinehaul(state: any, action: PayloadAction<Linehaul>) {
      
      const newLinehaul = action.payload.newRequest
        ? action.payload.newRequest
        : action.payload;

      if (Array.isArray(state.list)) {
        state.list?.unshift(newLinehaul);
        if (state.list.length > 10) {
          state.list.pop();
        }
      } else if (state.list && Array.isArray(state.list.requests)) {
        state?.list?.requests?.unshift(newLinehaul);
        if (state?.list?.requests?.length > 10) {
          state.list.requests.pop();
        }
      } else {
        state.list = [newLinehaul];
      }
    },

    linehaulStatusUpdate(state: any, action: PayloadAction<LinehaulStatusUpdatePayload>) {
      const { customId, status, assignedCompanyName, staffName } = action.payload;

      if (!customId) return;

      else if (state.list && Array.isArray(state.list.requests)) {
        const linehaul = state.list.requests.find((p: any) => p.customId === customId);
        if (linehaul) {
          linehaul.status = status;
          if (assignedCompanyName) linehaul.assignedCompanyName = assignedCompanyName;
          if (staffName) linehaul.staffName = staffName;
        }
      }
    },

    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },

    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
  },
});

export const {
  setLinehaulList,
  linehaulStatusUpdate,
  setLoading,
  setError,
  addLinehaul,
} = linehaulSlice.actions;

export default linehaulSlice.reducer;
